import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import LeaderboardHero from './components/LeaderboardHero';
import GlobalRankings from './components/GlobalRankings';
import RegionalLeaders from './components/RegionalLeaders';
import SeasonStats from './components/SeasonStats';

export default function Leaderboard() {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <LeaderboardHero />
      <GlobalRankings />
      <RegionalLeaders />
      <SeasonStats />
      <Footer />
    </div>
  );
}
